module.exports = __webpack_public_path__ + "img/logo2.41fc6b71.png";